import { render, staticRenderFns } from "./IconAddMore.vue?vue&type=template&id=7d237a28&scoped=true"
import script from "./IconAddMore.vue?vue&type=script&lang=js"
export * from "./IconAddMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d237a28",
  null
  
)

export default component.exports